import React from 'react';
import SingleBar from './SingleBar';
import 'aos/dist/aos.css';

export default function Skills(props) {
  return (

    <div id='skills' className='-z-50 bg-[#ecf0f5] mt-16 md:pl-[350px] pl-14 pr-7 pt-16 pb-16 flex flex-col space-y-4 ' onMouseOver={() => props.onHover("skills")}>
      
      <h1 className='text-3xl pt-2 font-[650] text-[#173b6c] '>Skills</h1>
      
      <hr className='relative pb-4 w-12 border-t-4 border-blue-400' />
      
      <div className='flex flex-col w- md:flex-row pt-2 pb-2 justify-around md:space-x-8'>
        
          <div data-aos="fade-up" className='flex flex-col space-y-2 md:w-1/2'>
            <SingleBar stype="C" prog="95%" prog2="95%"/>
            <SingleBar stype="C++" prog="85%" prog2="85%"/>
            <SingleBar stype="HTML" prog="80%" prog2="80%"/>
            <SingleBar stype="CSS" prog="75%" prog2="75%"/>
            <SingleBar stype="Javascript" prog="90%" prog2="90%"/>
          </div>

          <div data-aos="fade-up" className='flex flex-col space-y-2 md:w-1/2'>
            <SingleBar stype="Java" prog="85%" prog2="85%"/>
            <SingleBar stype="Python" prog="95%" prog2="95%"/>
            <SingleBar stype="ReactJs" prog="90%" prog2="90%"/>
            <SingleBar stype="NodeJs" prog="80%" prog2="80%"/>
            <SingleBar stype="MySQL" prog="95%" prog2="95%"/>
          </div>

        </div>
    </div>

  )
}
